import styled from "@emotion/styled";

export const SectionRoot = styled.div`
  padding: 2rem;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const SectionControls = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
